module.exports = __webpack_public_path__ + "static/media/ouzeria.5576ccb0.webp";